import { lazy, type ComponentType } from 'react';

const CHUNK_RELOAD_KEY = 'route-chunk-reloaded';

export function reloadOnceOnChunkError(error: unknown): Promise<never> {
  if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
    window.location.reload();
    return new Promise<never>(() => {});
  }

  throw error;
}

export function lazyChunk(
  load: () => Promise<Record<string, unknown>>,
  exportName: string
) {
  return lazy(() =>
    load()
      .then((module) => {
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        return { default: module[exportName] as ComponentType };
      })
      .catch(reloadOnceOnChunkError)
  );
}
